import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {
    DocumentTypeDto,
    ScanDocumentListItemDto,
    ScanDocumentSortByDto,
    ScanStatusDto,
    SortTypeDto
} from "../../api/sea";

class SeaDocumentListStore {
    get status(): ScanStatusDto[] | undefined {
        return this._status;
    }

    set status(value: ScanStatusDto[] | undefined) {
        this._status = value;
    }
    get type(): DocumentTypeDto[] | undefined {
        return this._type;
    }

    set type(value: DocumentTypeDto[] | undefined) {
        this._type = value;
    }
    get toAbsolute(): string | undefined {
        return this._toAbsolute;
    }

    set toAbsolute(value: string | undefined) {
        this._toAbsolute = value;
    }
    get fromAbsolute(): string | undefined {
        return this._fromAbsolute;
    }

    set fromAbsolute(value: string | undefined) {
        this._fromAbsolute = value;
    }
    get toRelative(): string | undefined {
        return this._toRelative;
    }

    set toRelative(value: string | undefined) {
        this._toRelative = value;
    }
    get fromRelative(): string | undefined {
        return this._fromRelative;
    }

    set fromRelative(value: string | undefined) {
        this._fromRelative = value;
    }
    get query(): string | undefined {
        return this._query;
    }

    set query(value: string | undefined) {
        this._query = value;
    }
    get sortType(): SortTypeDto | undefined {
        return this._sortType;
    }

    set sortType(value: SortTypeDto | undefined) {
        this._sortType = value;
    }
    get sortBy(): ScanDocumentSortByDto | undefined {
        return this._sortBy;
    }

    set sortBy(value: ScanDocumentSortByDto | undefined) {
        this._sortBy = value;
    }
    get items(): ScanDocumentListItemDto[] {
        return this._items;
    }

    set items(value: ScanDocumentListItemDto[]) {
        this._items = value;
    }

    get size(): number {
        return this._size;
    }

    set size(value: number) {
        this._size = value;
    }

    get page(): number {
        return this._page;
    }

    set page(value: number) {
        this._page = value;
    }

    get pages(): number {
        return this._pages;
    }

    set pages(value: number) {
        this._pages = value;
    }

    private _pages: number = 0
    private _page: number = 0
    private _size: number = 25

    private _sortBy: ScanDocumentSortByDto | undefined
    private _sortType: SortTypeDto | undefined
    private _query: string | undefined
    private _fromRelative: string | undefined
    private _toRelative: string | undefined
    private _fromAbsolute: string | undefined
    private _toAbsolute: string | undefined
    private _type: DocumentTypeDto[] | undefined
    private _status: ScanStatusDto[] | undefined

    private _items: ScanDocumentListItemDto[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        const {
            page,
            size,
            sortBy,
            sortType,
            toRelative,
            toAbsolute,
            fromRelative,
            fromAbsolute,
            status,
            type,
            query,
        } = this
        const result = await catchApi(async () => await api.sea.api.listDocuments({
            page: page - 1,
            size,
            sortBy,
            sortType,
            toRelative,
            toAbsolute,
            fromRelative,
            fromAbsolute,
            status,
            type,
            q: query,
        }))
        const data = result?.data
        this.pages = data?.totalPages || 0
        this.items = data?.items || []
    }
}

const seaDocumentListStore = new SeaDocumentListStore()

export {
    seaDocumentListStore
}
